import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MediaChange, MediaObserver,  } from '@angular/flex-layout';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { AddSentenceDialog } from './add-sentence/add-sentence.component';
import { EditImageDialog } from 'src/app/shared/components/edit-image/edit-image.component';
import { environment } from 'src/environments/environment';
import { DeleteConfirmationDialog } from 'src/app/shared/components/delete-confirmation/delete-confirmation.component';
import { ISentenceRow, IVoiceActor } from 'src/app/shared/models/lesson-content.model';

import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-sentences',
  templateUrl: './sentences.component.html',
  styleUrls: ['./sentences.component.scss']
})
export class SentencesComponent implements OnInit {

	sentences!: ISentenceRow[];

	@Input() set data(value: ISentenceRow[]) {
		this.sentences = value;
	}

	@Output() newData = new EventEmitter<ISentenceRow[]>();

	voiceActors: string[] = Object.values(IVoiceActor);

	cols: number = 0;
	gridByBreakpoint = {
		xl: 5,
		lg: 4,
		md: 3,
		sm: 2,
		xs: 1,
	}

	constructor(
		public dialog: MatDialog,
		private observableMedia: MediaObserver,
	) {
		this.cols = 5;
	}

	ngAfterContentInit() {
		this.observableMedia.asObservable().subscribe((change : MediaChange[]) => {
			for (let [key, value] of Object.entries(this.gridByBreakpoint)) {
				if (key === change[0].mqAlias) {
					this.cols = value;
				}
			}
		});
	}

	ngOnInit(): void {

	}

	addSentence() {
		const dialogRef = this.dialog.open(AddSentenceDialog, {
			width: '550px',
			data: {
				uuid: uuidv4(),
				affirmativeTrue: '',
			} as ISentenceRow,
		})

		dialogRef.afterClosed().subscribe((result: ISentenceRow) => {
			if (!result) {
				return;
			}

			this.sentences.push(result);
			this.sendData();
		})
	}

	createImage(id: string) {
		return `https://storage.googleapis.com/${environment.BUCKETS.CONTENT_BUCKET}/images/${id}.jpg`;
	}

	editImage(index: number, sent: ISentenceRow) {
		const dialogRef = this.dialog.open(EditImageDialog, {
			width: '350px',
			data: sent.imageId,
		});

		dialogRef.afterClosed().subscribe((result: string) => {
			if (!result) {
				return;
			}
			sent.imageId = result;
			this.sentences[index] = sent;
			this.sendData();
		});
	}

	remove(index: number) {
		const dialogRef = this.dialog.open(DeleteConfirmationDialog, {
			width: "350px",
			data: index,
		});

		dialogRef.afterClosed().subscribe((result: boolean) => {
			if (!result) {
				return;
			}

			this.sentences.splice(index, 1);
			this.sendData();
		});
	}

	copyImageName(index: number) {
		const sentence = this.sentences[index];
		navigator.clipboard.writeText(sentence.imageId);
	}

	sendData() {
		this.newData.emit(this.sentences);
	}
}
